import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function BannerContent({ rtl }) {
  const className = rtl
    ? "mobileapp_gcc p-100 rtl-style"
    : "mobileapp_gcc p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <div className="banenr_content">
              <h2>حلول رقمية مطورة للشركات الصغيرة والكبيرة</h2>
              <p>
                تيك ريڤول هي مركز قوة في مجال تطوير تطبيقات الهاتف المحمول و
                مواقع الويب، متواجدة الآن في دبي، الإمارات العربية المتحدة،
                سنقومبتوفير سنوات خبرتنا في التصميم والتطوير إلى الشرق الأوسط
                لدعم الحلول الرقمية المتطورة للشركات والمؤسسات.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                هيا بنا نبدأ
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/expert.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={900}
              height={750}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BannerContent;
